/** GraphQL Mutation that updates a customer address. */
export default `
  mutation usercomNewsletter($input: UsercomNewsletterInput) {
    usercomNewsletter(input: $input) {
      error
      message
    }
  }
`;
